import {
    mapMutations
  } from 'vuex'
export const GLOBAL_MIXINS = {
    data () {
        return {
         
        }
      },
    methods: {
        ...mapMutations([]),
        business_name() {
          var name = this.$store.state.settings.reduce((res,item)=>{
            if(item.alias == 'business_name') {
                res = item.value
            }
            return res
          },'')
          return name
        },
         business_address() {
          var name = this.$store.state.settings.reduce((res,item)=>{
            if(item.alias == 'business_address') {
                res = item.value
            }
            return res
          },'')
          return name
        },
         tin() {
          var name = this.$store.state.settings.reduce((res,item)=>{
            if(item.alias == 'tin') {
                res = item.value
            }
            return res
          },'')
          return name
        },
        
    } ///eof methods
}